import React, { useContext } from "react";
import { Input } from "antd";
import Form from "antd/lib/form/Form";
import { ImplementerProfileFormContext } from "../../ImplementerProfileFormContext";

export const ImplementerMissionInput = (props: any) => {
  const implementerAccountContext = useContext(ImplementerProfileFormContext);
  const {
    form,
    isBusy,
    onFieldsChange,
    implementerProfile
  } = implementerAccountContext;
  const { getFieldDecorator } = form;

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onFieldsChange({
      key: event.target.name,
      value: event.target.value
    });
  };

  return (
    <Form.Item label="Misión de la implementadora">
      {getFieldDecorator("implementerMission", {
        rules: [
          {
            required: true,
            message: "Por favor, ingresa la misión de la implementadora."
          }
        ],
        initialValue: implementerProfile?.implementerMission
      })(
        <Input
          disabled={isBusy}
          id="implementerMission"
          name="implementerMission"
          placeholder="Misión de la implementadora"
          onChange={onChange}
          size="large" />
      )}
    </Form.Item>
  );
};
